import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Layout from '../../../Layout/StandardLayout';
import { useIntercom } from '../../../../context/IntercomContext';

const ContactSupport = () => {
  const { openChat } = useIntercom();

  return (
    <Layout
      title="Support"
      description="Questions? Concerns? We are here to help!"
      breadcrumb="Help >> Support"
      breadCrumbs={[{ title: 'Help' }, { title: 'Support' }]}
      classProps="standard-width-with-sidebar"
    >
      <div className="maw-1200 flex-col-left">
        <div className="flex-col-left" style={{ marginBottom: '20px' }}>
          <div className="flex-row-nospacebetween-nowrap">
            <FontAwesomeIcon
              icon="fa-light fa-message-lines"
              style={{ marginTop: '12px', fontSize: 16 }}
              className="m-right-15 blue-link"
            />
            <p className="align-left" style={{ marginBottom: '0px' }}>
              <a
                id="ChatWithSupportButton"
                className="blue-link no-decoration fw-600 fs-14 mw-150 align-left no-wrap"
                href="#"
                onClick={e => {
                  e.preventDefault();
                  openChat();
                }}
              >
                Chat with Support
              </a>
            </p>
          </div>
          <div style={{ height: '35px' }} className="flex-row-nospacebetween-nowrap">
            <p className="fs-14 gray align-left m-top-20">Get instant answers using our webchat.</p>
          </div>
        </div>
        <div className="flex-col-left" style={{ marginBottom: '20px' }}>
          <div className="flex-row-nospacebetween-nowrap">
            <img
              className="m-right-15"
              style={{ marginTop: '12px' }}
              src="https://dashboard-v2-images.s3.amazonaws.com/letterHelp.svg"
            />
            <p className="align-left" style={{ marginBottom: '0px' }}>
              <a
                id="EmailSupportButton"
                className="blue-link no-decoration fw-600 fs-14 mw-150 align-left no-wrap"
                href="mailto: support@clientbook.com"
              >
                Email support@clientbook.com
              </a>
            </p>
          </div>
          <div style={{ height: '35px' }} className="flex-row-nospacebetween-nowrap">
            <p className="fs-14 gray align-left m-top-20">Email a question to our team</p>
          </div>
        </div>
        <div className="flex-col-left" style={{ marginBottom: '20px' }}>
          <div className="flex-row-nospacebetween-nowrap">
            <FontAwesomeIcon
              icon="fa-light fa-headset"
              style={{ marginTop: '12px', fontSize: 16 }}
              className="m-right-15 blue-link"
            />
            <p className="align-left" style={{ marginBottom: '0px' }}>
              <a
                id="HelpCenterButton"
                className="blue-link no-decoration fw-600 fs-14 mw-150 align-left no-wrap"
                href="https://clientbook.zendesk.com/hc/en-us"
                target="_blank"
                rel="noreferrer"
              >
                Visit our Help Center
              </a>
            </p>
          </div>
          <div style={{ height: '35px' }} className="flex-row-nospacebetween-nowrap">
            <p className="fs-14 gray align-left m-top-20">Visit our help center to search for how-to articles</p>
          </div>
        </div>
      </div>
    </Layout>
  );
};
export default ContactSupport;
